import type { RootData } from '~/root';
import { useRouteLoaderData } from '@remix-run/react';

export const useRootData = (): RootData => {
    return useRouteLoaderData('root') as RootData;
};
